import React from 'react'

import profilePicture from '../images/DONT SHOOT FILMS 3.JPG'

function AboutPage() {
  return (
    <div className="About container">
      <div className="justify-content-around">
        <img className="About-Image" src={profilePicture}></img>
        <br />
        <br />
        <div className="col-md-8 offset-md-2 About-text">
          <div className="Contact-details">
            <h5>027 420 6255</h5>
            <h5>ellajane.gilbert@gmail.com</h5>
          </div>
          <br />
          <br />
          <p>
            <strong>
              Ko Horouta te waka
              <br />
              Ko Manawaru te maunga
              <br />
              Ko Te Arai te awa
              <br />
              Ko Rongowhakaata te iwi
              <br />
              Ko Ngāti Kaipoho te hapu
              <br />
              Ko Te Poho O Rukupō te wharenui
              <br />
              Ko Manutuke te marae
              <br />
              Ko Ella Gilbert tōku ingoa
            </strong>
          </p>
          <br />
          <h1>some words from me, about me</h1>
          <p>
            I grew up on the beach in Pukerua Bay, Aotearoa.
          </p>
          <p>
            I love play fights and pottery.
          </p>
          <p>
            I am a performer and performance coach.
          </p>
          <p>
            I make theatre, film  and spaces for other performers to create.
          </p>
          {/* <p>
            3 things I’m always seeking to make powerfully possible:
            <br />
            Expression,   Exchange  +   Play
          </p> */}
          <p>
            I am an acting graduate of Te Kura Toi Whakaari O Aotearoa, the New Zealand School of Drama. I found this education wonderfully full on, and it helped  confirm my commitment to the art life.
          </p>
          <p>
            During this time my tenacity, leadership and openness caught the eye of NZ coaching legend Miranda Harcourt. Miranda mentored me on my first ever coaching job and continues to be a treasured collaborator and confidante.
          </p>
          <p>
            I further trained with Araitepō, a tikanga Maori high performance leadership program. The invaluable teachings of which are present in all my collaborations and projects.
          </p>
          <p>
            As an actor and a coach, I’m in it for the people.
          </p>
          <p>
            I am a creator of stories, of experiences and of connection.
            <br />
            I am proud to be an artist in Aotearoa.
          </p>
        </div>
      </div>
    </div>
  )
}

export default AboutPage
